import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_play",
  "use": "icon_play-usage",
  "viewBox": "0 0 46 52",
  "content": "<symbol viewBox=\"0 0 46 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 6.76779C2 3.14379 5.6793 0.848487 8.6822 2.59919L41.6709 21.8314C44.7764 23.6418 44.7764 28.3582 41.6709 30.1686L8.6823 49.4008C5.6793 51.1515 2 48.8562 2 45.2322V6.76779Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol